import thunkMiddleware from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { saveState, loadState } from './localStorage';

import { auth } from './auth/reducer';
import { analytic } from './analytic/reducer';
import { interest } from './interest/reducer';
import { transferAct } from './transferAct/reducer';
import { stock } from './stock/reducer';
import { feedback } from './feedback/reducer';

import { client } from './client/reducer';
import { cashWarrant } from './cashWarrant/reducer';
import { requestCancellation } from './requestsCancellation/reducer';

const persistedState = loadState();

export const dataProvider = () => {
  const reducers = combineReducers({
    auth,
    transferAct,
    feedback,
    analytic,
    stock,
    client,
    interest,
    cashWarrant,
    requestCancellation,
  });
  const middlewares = [thunkMiddleware];

  const withDevTools =
    process.env.REACT_APP_DEVELOPMENT_MODE === 'true'
      ? composeWithDevTools(applyMiddleware(...middlewares))
      : applyMiddleware(...middlewares);

  const store = createStore(reducers, persistedState, withDevTools);

  store.subscribe(() => {
    saveState({
      auth: store.getState().auth,
    });
  });

  return store;
};
